import type { FC, PropsWithChildren} from "react";
import { createContext, useState } from "react";

type CashbackDashboardType = {
    totalWithdrawalAmount: string | null;
    setTotalWithdrawalAmount: (amount: string | null) => void;
    updateTransactions: number;
    setUpdateTransactions: () => void;
    cleanUpdateTransactions: () => void;
};

const CashbackDashboardContext = createContext<CashbackDashboardType>({
    totalWithdrawalAmount: null,
    setTotalWithdrawalAmount: () => {},
    updateTransactions: 0,
    setUpdateTransactions: () => {},
    cleanUpdateTransactions: () => {},
});

const CashbackDashboardProvider: FC<PropsWithChildren> = ({ children }) => {
    const [totalWithdrawal, setTotalWithdrawal] = useState<string | null>(null);
    const [updateTrans, setUpdateTrans] = useState<number>(0);

    const setUpdateTransactions = () => setUpdateTrans((previousS) => previousS + 1);

    const cleanUpdateTransactions = () => {
        if (updateTrans > 0) {
            setUpdateTrans(0);
        }
    };

    const value: CashbackDashboardType = {
        totalWithdrawalAmount: totalWithdrawal,
        setTotalWithdrawalAmount: setTotalWithdrawal,
        updateTransactions: updateTrans,
        setUpdateTransactions,
        cleanUpdateTransactions,
    };

    return (
        <CashbackDashboardContext.Provider value={value}>
            {children}
        </CashbackDashboardContext.Provider>
    );
};

export { CashbackDashboardContext, CashbackDashboardProvider };
